module.exports = __webpack_public_path__ + "img/d090631.png";